import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from "./baseQuery";

export const productGroupingApi = createApi({
    reducerPath: 'productGroupingApi',
    baseQuery: baseQuery,
    tagTypes: [
        'ProductGroupConfig',
        'ProductGroups'
    ],
    endpoints: (builder) => ({
        createProductGroupConfig: builder.mutation({
            query: ({
                client,
                clientRegion,
                configName,
                platform
            }) => ({
                url: '/settings/product_group_config' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&platform=" + platform,
                method: 'PUT',
            }),
            invalidatesTags: ['ProductGroupConfig'],
        }),
        deleteProductGroup: builder.mutation({
            query: ({
                client,
                clientRegion,
                configName,
                productGroupName,
                platform
            }) => ({
                url: '/settings/product_group' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&product_group_name=" + productGroupName + "&platform=" + platform,
                method: 'DELETE',
            }),
            invalidatesTags: ['ProductGroups'],
        }),
        listProductGroupConfigs: builder.query({
            query: ({ client, clientRegion, platform }) => '/settings/product_group_configs' + "?client=" + client + "&client_region=" + clientRegion + "&platform=" + platform,
            providesTags: ['ProductGroupConfig'],
        }),
        activateProductGroupConfig: builder.mutation({
            query: ({
                client,
                clientRegion,
                configName,
                platform
            }) => ({
                url: '/settings/activate_product_group_config' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&platform=" + platform,
                method: 'PUT',
            }),
            invalidatesTags: ['ProductGroupConfig'],
        }),
        getActiveProductGroupConfig: builder.query({
            query: ({ client, clientRegion, platform }) => '/settings/active_product_group_config' + "?client=" + client + "&client_region=" + clientRegion + "&platform=" + platform,
            providesTags: ['ProductGroupConfig'],
        }),
        deleteProductGroupConfig: builder.mutation({
            query: ({
                client,
                clientRegion,
                configName,
                platform
            }) => ({
                url: '/settings/product_group_config' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&platform=" + platform,
                method: 'DELETE',
            }),
            invalidatesTags: ['ProductGroupConfig'],
        }),
        addAProductGroup: builder.mutation({
            query: ({
                client,
                clientRegion,
                configName,
                productGroup,
                platform
            }) => ({
                url: '/settings/product_group' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&product_group_name=" + productGroup + "&platform=" + platform,
                method: 'PUT',
            }),
            invalidatesTags: ['ProductGroups'],
        }),
        getProductsTable: builder.query({
            query: ({ client, clientRegion, configName, startDate, endDate, platform }) => '/settings/product_table' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&start_date=" + startDate + "&end_date=" + endDate + "&platform=" + platform,
            providesTags: ['ProductGroups'],
        }),
        getProductGroups: builder.query({
            query: ({ client, clientRegion, configName, platform }) => '/settings/product_groups' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + '&platform=' + platform,
            providesTags: ['ProductGroups'],
        }),
        getProductGroupsInConfig: builder.query({
            query: ({ client, clientRegion, configName, platform }) => '/settings/product_groups_in_config' + "?client_name=" + client + "&client_region=" + clientRegion + "&selected_config=" + configName + '&platform=' + platform,
            providesTags: ['ProductGroups'],
        }),
        assignToProductGroup: builder.mutation({
            query: ({
                client,
                clientRegion,
                configName,
                productGroup,
                products,
                platform
            }) => ({
                url: '/settings/assign_to_product_group' + "?client=" + client + "&client_region=" + clientRegion + "&config_name=" + configName + "&product_group_name=" + productGroup + '&platform=' + platform,
                method: 'PUT',
                body: {
                    products: products
                }
            }),
            invalidatesTags: ['ProductGroups'],
        }),
    })
});

export const {
    useCreateProductGroupConfigMutation,
    useListProductGroupConfigsQuery,
    useActivateProductGroupConfigMutation,
    useGetActiveProductGroupConfigQuery,
    useDeleteProductGroupConfigMutation,
    useAddAProductGroupMutation,
    useGetProductsTableQuery,
    useGetProductGroupsQuery,
    useGetProductGroupsInConfigQuery,
    useAssignToProductGroupMutation,
    useDeleteProductGroupMutation,
} = productGroupingApi;

export default productGroupingApi.reducer;